import { Flex, Header, Modal } from 'components';
import './style.scss';

function ModalLoader() {
  return (
    <Modal size='fullscreen'>
      <Flex justifyContent='center'>
        <Flex
          direction='column'
          gap={40}
          alignItems='center'
        >
          <div className='loader-spinner-n2sa' />
          <Header align='center'>Загрузка...</Header>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default ModalLoader;
